import { AsyncPipe } from '@angular/common';
import * as i0 from '@angular/core';
import { inject, Component, ChangeDetectionStrategy, Input } from '@angular/core';
import * as i1 from '@taiga-ui/core';
import { TuiButton, TuiDropdown, TuiHint } from '@taiga-ui/core';
import { TUI_EDITOR_OPTIONS, TUI_EDITOR_TOOLBAR_TEXTS } from '@taiga-ui/editor/common';
import { TuiTiptapEditorService } from '@taiga-ui/editor/directives';
import { combineLatest, of, map } from 'rxjs';
function TuiAlignContent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "button", 4);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵlistener("click", function TuiAlignContent_ng_template_5_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.editor == null ? null : ctx_r1.editor.onAlign("left"));
    });
    i0.ɵɵtext(3, " Left align ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 4);
    i0.ɵɵpipe(5, "async");
    i0.ɵɵlistener("click", function TuiAlignContent_ng_template_5_Template_button_click_4_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.editor == null ? null : ctx_r1.editor.onAlign("center"));
    });
    i0.ɵɵtext(6, " Center align ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "button", 4);
    i0.ɵɵpipe(8, "async");
    i0.ɵɵlistener("click", function TuiAlignContent_ng_template_5_Template_button_click_7_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.editor == null ? null : ctx_r1.editor.onAlign("right"));
    });
    i0.ɵɵtext(9, " Right align ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "button", 4);
    i0.ɵɵpipe(11, "async");
    i0.ɵɵlistener("click", function TuiAlignContent_ng_template_5_Template_button_click_10_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.editor == null ? null : ctx_r1.editor.onAlign("justify"));
    });
    i0.ɵɵtext(12, " Justify align ");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_3_0;
    let tmp_5_0;
    let tmp_7_0;
    let tmp_9_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("iconStart", ctx_r1.options.icons.textAlignLeft)("tuiHint", (tmp_3_0 = i0.ɵɵpipeBind1(2, 8, ctx_r1.texts$)) == null ? null : tmp_3_0.justifyLeft);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("iconStart", ctx_r1.options.icons.textAlignCenter)("tuiHint", (tmp_5_0 = i0.ɵɵpipeBind1(5, 10, ctx_r1.texts$)) == null ? null : tmp_5_0.justifyCenter);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("iconStart", ctx_r1.options.icons.textAlignRight)("tuiHint", (tmp_7_0 = i0.ɵɵpipeBind1(8, 12, ctx_r1.texts$)) == null ? null : tmp_7_0.justifyRight);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("iconStart", ctx_r1.options.icons.textAlignJustify)("tuiHint", (tmp_9_0 = i0.ɵɵpipeBind1(11, 14, ctx_r1.texts$)) == null ? null : tmp_9_0.justifyFull);
  }
}
let TuiAlignContent = /*#__PURE__*/(() => {
  class TuiAlignContent {
    constructor() {
      this.localEditor = null;
      this.options = inject(TUI_EDITOR_OPTIONS);
      this.injectionEditor = inject(TuiTiptapEditorService, {
        optional: true
      });
      this.texts$ = inject(TUI_EDITOR_TOOLBAR_TEXTS);
      this.alignState$ = null;
    }
    set inputEditor(value) {
      this.localEditor = value;
      this.initStream();
    }
    ngOnInit() {
      this.initStream();
    }
    get editor() {
      return this.injectionEditor ?? this.localEditor;
    }
    initStream() {
      this.alignState$ = combineLatest([this.editor?.isActive$({
        textAlign: 'left'
      }) ?? of(false), this.editor?.isActive$({
        textAlign: 'right'
      }) ?? of(false), this.editor?.isActive$({
        textAlign: 'center'
      }) ?? of(false), this.editor?.isActive$({
        textAlign: 'justify'
      }) ?? of(false)]).pipe(map(([left, right, center, justify]) => ({
        left,
        right,
        center,
        justify
      })));
    }
    static {
      this.ɵfac = function TuiAlignContent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiAlignContent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TuiAlignContent,
        selectors: [["tui-align-content"]],
        inputs: {
          inputEditor: [0, "editor", "inputEditor"]
        },
        decls: 7,
        vars: 9,
        consts: [["alignDropdown", ""], [3, "tuiDropdown", "tuiDropdownOpen"], ["appearance", "icon", "automation-id", "toolbar__align-button", "size", "s", "tuiHintDescribe", "", "tuiHintDirection", "top-left", "tuiIconButton", "", "type", "button", 3, "iconStart", "tuiHint"], [1, "t-dropdown"], ["appearance", "icon", "size", "s", "tuiIconButton", "", "type", "button", 1, "t-option", "t-option_margin", 3, "click", "iconStart", "tuiHint"]],
        template: function TuiAlignContent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1)(1, "button", 2);
            i0.ɵɵpipe(2, "async");
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "async");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, TuiAlignContent_ng_template_5_Template, 13, 16, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            let tmp_4_0;
            let tmp_5_0;
            const alignDropdown_r3 = i0.ɵɵreference(6);
            i0.ɵɵproperty("tuiDropdown", alignDropdown_r3)("tuiDropdownOpen", false);
            i0.ɵɵadvance();
            i0.ɵɵproperty("iconStart", ctx.options.icons.textAlignPreview)("tuiHint", (tmp_4_0 = i0.ɵɵpipeBind1(2, 5, ctx.texts$)) == null ? null : tmp_4_0.justify);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", (tmp_5_0 = i0.ɵɵpipeBind1(4, 7, ctx.texts$)) == null ? null : tmp_5_0.justify, " ");
          }
        },
        dependencies: [AsyncPipe, TuiButton, i1.TuiDropdownDirective, i1.TuiDropdownOpen, i1.TuiHintDirective, i1.TuiHintDescribe],
        styles: [".t-dropdown[_ngcontent-%COMP%]{padding:.75rem}.t-option[_ngcontent-%COMP%]{transition-property:background;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out}.t-option[_ngcontent-%COMP%]:hover{background:var(--tui-background-neutral-1-hover)}.t-option_margin[_ngcontent-%COMP%]{margin:0 .25rem}.t-plate[_ngcontent-%COMP%]{position:absolute;top:1.9rem;left:.25rem;inline-size:1.5rem;block-size:.25rem;pointer-events:none}.t-plate_paint[_ngcontent-%COMP%]{left:.375rem;inline-size:1.25rem}.t-color-picker[_ngcontent-%COMP%]{box-sizing:border-box;max-inline-size:22.6rem}"],
        changeDetection: 0
      });
    }
  }
  return TuiAlignContent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiAlignContent };
